export class SharedAPIConfig {
  public static DEFAULT_PAGE = 1;
  public static DEFAULT_SORT: 'asc' | 'desc' = 'desc';
  public static DEFAULT_PAGE_SIZE_OPTIONS = [10, 25, 50, 100];
}
